import React from 'react';
import { Modal } from '@design-system';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export const ExistingAnnotationsModal = ({
  setShowModal,
  isOpen,
  onSuccess,
  onCancel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      showModal={isOpen}
      setShowModal={setShowModal}
      onSuccess={onSuccess}
      showCancel
      cancelText={t(translations.COMMON.BACK)}
      handleCancel={onCancel}
      width="md:w-6/12 xl:w-4/12"
      title={t(translations.MODALS.EXISTING_ANNOTATIONS)}>
      <>
        <p className="max-w-[500px] text-center text-paragraph md:text-subtitle">
          {t(translations.DOCUMENT_PAGES.EXISTING_ANNOTATIONS)}
        </p>
        <p className="mt-10 max-w-[500px] text-center text-paragraph md:text-subtitle">
          {t(translations.COMMON.WANT_TO_CONTINUE)}
        </p>
      </>
    </Modal>
  );
};
